<h1 mat-dialog-title>{{'Confirmation' | translate}}</h1>
<mat-dialog-content class="mat-typography">
    <h3>{{this.message | translate}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
  <button mat-button (click)="execute()">{{buttonText | translate}}</button>
</mat-dialog-actions>
